
import { isEmpty } from 'radash';
import { useCallback } from 'react';

import { LOCAL_STORAGE } from '@/constants';
import { useTranslation } from '@/hooks/useTranslation';
import { DataModelAttribute } from '@/types/DataModel';

const useAttributeLabelTranslator = () => {

    const { t } = useTranslation();
    const lookupLanguage = localStorage.getItem(LOCAL_STORAGE.LANGUAGE_KEY);

    function getTranslationFromObject(object: any, type: any, defaultValueFn: any) {
        // Ignore non-objects or 'empty' objects
        if (typeof object !== 'object' || object === null || Object.keys(object).length === 0) {
            return defaultValueFn(object);
        }

        let result;
        // Try translations from translation map first
        const translationMap = object[`${type}s`];
        if (translationMap && typeof translationMap === 'object') {
            // Find the first non-empty translation using the lookup languages hierarchy
            if (lookupLanguage && translationMap[lookupLanguage]) {
                result = translationMap[lookupLanguage];
            }
        }

        return result || defaultValueFn(object) || object[type];
    }

    function getDefaultAttributeLabel(attribute: DataModelAttribute) {
        if (typeof attribute === 'object' && attribute !== null) {
            return translateValue('attribute.', attribute.name, attribute.label);
        } else {
            return translateValue('attribute.', attribute);
        }
    }
    const translateValue = (prefix: string, value: string, defaultValue?: any) => {
        defaultValue = defaultValue || value;
        const key = `${prefix}${value}`;
        const result = t(key);
        if (result == key && !isEmpty(defaultValue)) {
            return defaultValue;
        }
        return result;
    };

    const translateAttributeLabel = useCallback((attribute: DataModelAttribute) => {
        return getTranslationFromObject (attribute, 'label', getDefaultAttributeLabel);
    //eslint-disable-next-line
    }, []);

    return { translateAttributeLabel };

};

export { useAttributeLabelTranslator };
